import React from "react";
import ReactECharts from "echarts-for-react";

const PieChart = ({ stocks = [] }) => {
  // ✅ Filter valid stocks
  const validStocks = stocks.filter(
    s => s.company && Number(s.qty) > 0
  );

  // ✅ Convert to pie data
  const pieData = validStocks.map(s => ({
    name: s.company.name,
    value: Number(s.qty),
  }));

  const option = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} Qty ({d}%)",   // 👈 % auto calculated
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    series: [
      {
        name: "Quantity Distribution",
        type: "pie",
        radius: "65%",
        center: ["50%", "50%"],
        data: pieData,
        label: {
          formatter: "{b}\n{d}%",          // 👈 show % on slice
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0,0,0,0.3)",
          },
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: 400 }}
      notMerge={true}
    />
  );
};

export default PieChart;
